export default __webpack_public_path__ + "static/media/Engagement-Regular.cc59fe64.ttf";